import { Analysis } from 'common-spectrum';
import { oanParseHitec } from 'physical-chemistry-parser';

export function fromHitec(xls, res) {
  let analysis = new Analysis();
  const parsed = oanParseHitec(xls, res);

  let meta = {};
  for (let key in parsed.meta) {
    meta = { ...meta, ...parsed.meta[key] };
  }

  const cheminfo = {};

  meta.cheminfo = cheminfo;

  analysis.pushSpectrum(
    {
      x: parsed.variables.x,
      y: parsed.variables.y,
    },
    {
      dataType: 'Oil Absorption Number (OAN)',
      title: meta.Meta,
      meta,
    },
  );

  return analysis;
}
